<template>
  <li v-if="node.name" class="treeNode">
    <div class="node-scope">
      <div class="node-wrap">
        <i
          v-if="node.children && node.children.length"
          class="el-icon-caret-right"
          :class="node.children && node.children.length ? activeBtn : ''"
          @click.stop="treeToggle"
        ></i>
        <p
          class="node-item"
          :style="indent"
          :class="{
            'node-item-active': !(node.children && node.children.length)
          }"
          @dragstart="dragstart(node)"
          @dragover="dragover($event)"
          @drop="drop(node)"
        >
          <span
            :draggable="dragCtrl"
            class="omitText"
            @click.stop="treeNodeClick(node)"
            :class="{ activeNameBgd: node.id === Number($route.query.id) }"
          >
            {{ node.name }}
          </span>
        </p>
        <!-- <span class="node-num">{{node.id}}</span> -->
        <p class="add-delete-icon-wrap">
          <i
            class="editor-icon"
            @click.stop="editorNode(node)"
            v-if="
              (!node.parent_id && node.write === 1) ||
                (!node.parent_id && node.write === 2)
            "
          ></i>
          <i
            class="delete-icon"
            @click.stop="delNode(node)"
            v-if="node.parent_id || node.write === 1"
          ></i>
          <i
            class="add-icon"
            @click.stop="addChildNode(node)"
            v-if="!node.parent_id"
          ></i>
          <i
            class="el-icon-refresh refresh-icon"
            @click.stop="refreshNode(node)"
            v-if="!node.parent_id"
          ></i>
        </p>
      </div>
      <el-collapse-transition>
        <ul v-show="chevron">
          <Draggable
            v-model="node.children"
            @change="changeNodeChild(node.children)"
            :animation="150"
            class="draggableTreeItem"
          >
            <sideBar
              v-if="node.children && node.children.length"
              v-for="(row, idx) in node.children"
              :node="row"
              :index="idx"
              :key="idx"
              :depth="depth + 1"
              :dragCtrl="dragCtrl"
              @addChildNode="addChildNode"
              @editorNode="editorNode"
              @delNode="delNode"
              @treeNodeClick="treeNodeClick"
              @dragstart="dragstart"
              @drop="drop"
              @changeTreeNodeChild="changeNodeChild"
            />
          </Draggable>
        </ul>
      </el-collapse-transition>
    </div>
  </li>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Draggable from "vuedraggable";

export default {
  name: "sideBar",
  props: ["node", "index", "depth", "dragCtrl"],
  computed: {
    indent() {
      return { width: `${170 - this.depth * 20}px` };
    }
  },
  components: {
    Draggable
  },
  data() {
    return {
      chevron: true,
      activeBtn: "active-tree-minus"
    };
  },
  methods: {
    treeToggle() {
      this.chevron = !this.chevron;
      this.activeBtn = this.chevron ? "active-tree-minus" : "active-tree-add";
    },
    addChildNode(val) {
      this.$emit("addChildNode", val);
    },
    refreshNode(val) {
      this.$emit("refreshNode", val);
    },
    editorNode(val) {
      this.$emit("editorNode", val);
    },
    delNode(val) {
      this.$emit("delNode", val);
    },
    treeNodeClick(val) {
      this.$emit("treeNodeClick", val);
    },
    dragstart(val) {
      if (!val.parent_id) {
        this.$emit("dragstart", val);
      }
    },
    dragover(event) {
      event.preventDefault();
    },
    drop(val) {
      if (!val.parent_id) {
        this.$emit("drop", val);
      }
    },

    changeNodeChild(arr) {
      this.$emit("changeTreeNodeChild", arr);
    }
  }
};
</script>

<style lang="scss" src="./index.scss" scoped></style>
